import { convertFromRaw } from 'wix-rich-content-editor/dist/lib/editorStateConversion.cjs';

export const createInitialDraftJsContentWithMention = ({ name, slug, id, prefix = '@' }) =>
  convertFromRaw({
    blocks: [
      {
        key: 'frocn',
        text: `${prefix}${name} `,
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [
          {
            offset: 0,
            length: prefix.length + name.length,
            key: 0,
          },
        ],
        data: {},
      },
    ],
    entityMap: {
      0: {
        type: 'mention',
        mutability: 'SEGMENTED',
        data: {
          mention: {
            name,
            slug,
            id,
          },
        },
      },
    },
  });
